import { z } from "zod/v4";

import { ExperienceDtoSchema } from "../../../dtos/experiences";
import {
  PatchVariationDtoSchema,
  VariationDtoSchema,
} from "../../../dtos/variations";

export const PatchBuilderVariationsRequestPathParamSchema = z.object({
  experienceId: z.uuid(),
});

export type PatchBuilderVariationsRequestPathParamType = z.infer<
  typeof PatchBuilderVariationsRequestPathParamSchema
>;

export const PatchBuilderVariationsRequestBodySchema = z.object({
  variations: PatchVariationDtoSchema.array(),
});

export type PatchBuilderVariationsRequestBodyType = z.infer<
  typeof PatchBuilderVariationsRequestBodySchema
>;

export const PatchBuilderVariationsResponseBodySchema = z.object({
  experiences: ExperienceDtoSchema.array(),
});

export type PatchBuilderVariationsResponseBodyType = z.infer<
  typeof PatchBuilderVariationsResponseBodySchema
>;
